import React, { type ReactNode } from 'react';

import { Typography } from '../Typography';

import {
    ButtonDisabledHero,
    ButtonDisabledLarge,
    ButtonDisabledSmall,
    ButtonPrimaryHero,
    ButtonPrimaryLarge,
    ButtonPrimarySmall,
    ButtonSecondaryHero,
    ButtonSecondaryLarge,
    ButtonSecondarySmall,
    ButtonTertiaryHero,
    ButtonTertiaryLarge,
    ButtonTertiarySmall,
    IconContainer,
} from './styles';

export type ButtonButtonDeprecatedProps = {
    color?: 'primary' | 'secondary' | 'tertiary';
    background?: 'dark' | 'light';
    children: ReactNode;
    classes?: string[];
    disabled?: boolean;
    fluid?: boolean;
    icon?: React.ReactElement;
    onClick?: (e: React.MouseEvent<HTMLElement>) => void;
    size: 'hero' | 'large' | 'small';
};

export const ButtonDeprecated = ({
    color,
    background,
    children,
    classes,
    disabled,
    icon,
    fluid,
    onClick,
    size,
}: ButtonButtonDeprecatedProps) => {
    const setWrapper = () => {
        if (disabled) {
            switch (size) {
                case 'hero':
                    return ButtonDisabledHero;
                case 'large':
                    return ButtonDisabledLarge;
                case 'small':
                    return ButtonDisabledSmall;
            }
        }
        switch (size) {
            case 'hero':
                switch (color) {
                    case 'primary':
                        return ButtonPrimaryHero;
                    case 'secondary':
                        return ButtonSecondaryHero;
                    case 'tertiary':
                    default:
                        return ButtonTertiaryHero;
                }
            case 'large':
                switch (color) {
                    case 'primary':
                        return ButtonPrimaryLarge;
                    case 'secondary':
                        return ButtonSecondaryLarge;
                    case 'tertiary':
                    default:
                        return ButtonTertiaryLarge;
                }
            case 'small':
                switch (color) {
                    case 'primary':
                        return ButtonPrimarySmall;
                    case 'secondary':
                        return ButtonSecondarySmall;
                    case 'tertiary':
                    default:
                        return ButtonTertiarySmall;
                }
        }
    };

    const ElementWrapper = setWrapper();

    const labelSize = () => {
        switch (size) {
            case 'hero':
                return 20;
            case 'large':
                return 18;
            case 'small':
            default:
                return 14;
        }
    };

    return (
        <ElementWrapper
            background={background || 'dark'}
            className={classes ? classes.join(' ') : ''}
            color={color || 'tertiary'}
            disabled={!!disabled}
            fluid={!!fluid}
            onClick={onClick}
            size={size}
        >
            {icon && <IconContainer className="yat-button-icon">{icon}</IconContainer>}
            <Typography color="inherit" size={labelSize()} type="label">
                {children}
            </Typography>
        </ElementWrapper>
    );
};
